module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "card-client dashboard-card dashboard-card--bordered dashboard-card--hoverable"
  }, [_c('header', {
    staticClass: "dashboard-card__header"
  }, [_c('img', {
    staticClass: "dashboard-card__icon",
    attrs: {
      "src": _vm.imgUser,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dashboard-card__header-info"
  }, [_c('h4', {
    staticClass: "dashboard-card__name"
  }, [_vm._v(_vm._s(_vm.clientName))]), _vm._v(" "), _c('span', {
    staticClass: "dashboard-status dashboard-status--client"
  }, [_vm._v(_vm._s(_vm.clientStatus))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.user.id
        }
      }
    }
  }, [_c('svg', {
    staticClass: "dashboard-card__arrow",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.5 15L12.5 10L7.5 5",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])], 1), _vm._v(" "), _c('section', {
    staticClass: "dashboard-card__contact"
  }, [(_vm.clientEmail) ? _c('a', {
    staticClass: "dashboard-card__contact-link",
    attrs: {
      "href": ("mailto:" + _vm.clientEmail)
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgMail,
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.clientEmail) + "\n\t\t")]) : _vm._e(), _vm._v(" "), (_vm.clientPhone) ? _c('a', {
    staticClass: "dashboard-card__contact-link",
    attrs: {
      "href": ("tel:" + _vm.clientPhone)
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPhone,
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.clientPhone) + "\n\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dashboard-info-row"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgCalendar,
      "alt": ""
    }
  }), _vm._v("\n\t\t\tClient depuis " + _vm._s(_vm.daysSinceCreation)), (_vm.creationDate) ? [_vm._v(" (le " + _vm._s(_vm.creationDate) + ")")] : _vm._e()], 2)]), _vm._v(" "), (_vm.actions && _vm.actions.length > 0) ? _c('footer', {
    staticClass: "card-client__actions"
  }, _vm._l((_vm.actions), function(action, index) {
    return _c('div', {
      key: index,
      staticClass: "dashboard-action",
      class: [_vm.getActionClass(action), {
        'dashboard-action--warning': action.daysUntil < 0
      }]
    }, [_c('img', {
      staticClass: "dashboard-action__icon",
      attrs: {
        "src": _vm.imgCalendar,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "dashboard-action__content"
    }, [_c('p', {
      staticClass: "dashboard-action__title"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.getActionLabel(action)) + "\n\t\t\t\t\t"), (action.daysUntil < 0) ? _c('span', {
      staticClass: "dashboard-action__warning-badge"
    }, [_vm._v("En retard")]) : _vm._e()]), _vm._v(" "), (action.date) ? _c('p', {
      staticClass: "dashboard-action__date"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.formatDaysText(action.daysUntil)) + "\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), (action.type === 'renouvellement') ? _c('label', {
      staticClass: "dashboard-action__checkbox",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "disabled": _vm.renewalLoading
      },
      on: {
        "change": function($event) {
          return _vm.onRenewalCheck(action)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dashboard-action__checkbox-label"
    }, [_vm._v("Fait")])]) : _vm._e()])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-129347b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Board/CardClient.vue
// module id = 1071
// module chunks = 0